 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"common":"common","views-modules-promotion-promotion-module-ngfactory":"views-modules-promotion-promotion-module-ngfactory","views-modules-referral-referral-module-ngfactory":"views-modules-referral-referral-module-ngfactory","default~pages-prediction-prediction-module-ngfactory~views-modules-member-member-module-ngfactory~vi~36c8596f":"default~pages-prediction-prediction-module-ngfactory~views-modules-member-member-module-ngfactory~vi~36c8596f","default~views-modules-info-info-module-ngfactory~views-modules-vip-vip-module-ngfactory":"default~views-modules-info-info-module-ngfactory~views-modules-vip-vip-module-ngfactory","views-modules-vip-vip-module-ngfactory":"views-modules-vip-vip-module-ngfactory","default~views-modules-member-member-module-ngfactory~views-modules-mint-girl-mint-girl-module-ngfactory":"default~views-modules-member-member-module-ngfactory~views-modules-mint-girl-mint-girl-module-ngfactory","views-modules-member-member-module-ngfactory":"views-modules-member-member-module-ngfactory","views-modules-info-info-module-ngfactory":"views-modules-info-info-module-ngfactory","views-modules-mint-girl-mint-girl-module-ngfactory":"views-modules-mint-girl-mint-girl-module-ngfactory","firebase-messaging":"firebase-messaging","views-modules-external-link-external-link-module-ngfactory":"views-modules-external-link-external-link-module-ngfactory","views-modules-lucky-spin-lucky-spin-module-ngfactory":"views-modules-lucky-spin-lucky-spin-module-ngfactory","views-modules-main-main-module-ngfactory":"views-modules-main-main-module-ngfactory","default~pages-home-home-module-ngfactory~pages-landing-landing-module-ngfactory":"default~pages-home-home-module-ngfactory~pages-landing-landing-module-ngfactory","default~pages-home-home-module-ngfactory~pages-signup-signup-module-ngfactory":"default~pages-home-home-module-ngfactory~pages-signup-signup-module-ngfactory","pages-home-home-module-ngfactory":"pages-home-home-module-ngfactory","pages-landing-landing-module-ngfactory":"pages-landing-landing-module-ngfactory","pages-signup-signup-module-ngfactory":"pages-signup-signup-module-ngfactory","game-game-module-ngfactory":"game-game-module-ngfactory","pages-forgot-password-forgot-password-module-ngfactory":"pages-forgot-password-forgot-password-module-ngfactory","pages-forgot-username-forgot-username-module-ngfactory":"pages-forgot-username-forgot-username-module-ngfactory","pages-login-login-module-ngfactory":"pages-login-login-module-ngfactory","pages-maintenance-maintenance-module-ngfactory":"pages-maintenance-maintenance-module-ngfactory","pages-processing-transaction-processing-transaction-module-ngfactory":"pages-processing-transaction-processing-transaction-module-ngfactory","pages-verify-email-verify-email-module-ngfactory":"pages-verify-email-verify-email-module-ngfactory","pages-crash-game-crash-game-module-ngfactory":"pages-crash-game-crash-game-module-ngfactory","pages-esports-esports-module-ngfactory":"pages-esports-esports-module-ngfactory","pages-fishing-fishing-module-ngfactory":"pages-fishing-fishing-module-ngfactory","pages-launch-game-in-iframe-launch-game-in-iframe-module-ngfactory":"pages-launch-game-in-iframe-launch-game-in-iframe-module-ngfactory","pages-launch-game-launch-game-module-ngfactory":"pages-launch-game-launch-game-module-ngfactory","pages-live-casino-live-casino-module-ngfactory":"pages-live-casino-live-casino-module-ngfactory","pages-live-casino-main-live-casino-main-module-ngfactory":"pages-live-casino-main-live-casino-main-module-ngfactory","pages-lottery-lottery-module-ngfactory":"pages-lottery-lottery-module-ngfactory","pages-slots-main-slots-main-module-ngfactory":"pages-slots-main-slots-main-module-ngfactory","pages-slots-slots-module-ngfactory":"pages-slots-slots-module-ngfactory","pages-sports-sports-module-ngfactory":"pages-sports-sports-module-ngfactory","pages-table-table-module-ngfactory":"pages-table-table-module-ngfactory","pages-prediction-prediction-module-ngfactory":"pages-prediction-prediction-module-ngfactory"}[chunkId]||chunkId) + "-es2015." + {"common":"59f3f3a9ecf21e2b58b8","views-modules-promotion-promotion-module-ngfactory":"91d0796859ae7a1b67b6","views-modules-referral-referral-module-ngfactory":"5a6cbc1302b4eb514f37","default~pages-prediction-prediction-module-ngfactory~views-modules-member-member-module-ngfactory~vi~36c8596f":"1ac1e62516f8670d27bf","default~views-modules-info-info-module-ngfactory~views-modules-vip-vip-module-ngfactory":"76ffc8bfec64f967aa4e","views-modules-vip-vip-module-ngfactory":"7eca895f113725dd0723","default~views-modules-member-member-module-ngfactory~views-modules-mint-girl-mint-girl-module-ngfactory":"08b93b04018c293ed1bf","views-modules-member-member-module-ngfactory":"1065c2a66c65b34d0719","views-modules-info-info-module-ngfactory":"7d9c12e7449409b57306","views-modules-mint-girl-mint-girl-module-ngfactory":"cea474131331fc0d3099","firebase-messaging":"21871492425f8e56e45f","views-modules-external-link-external-link-module-ngfactory":"6adc6585b3d6a8f32e87","views-modules-lucky-spin-lucky-spin-module-ngfactory":"bfd7af53762237113c69","views-modules-main-main-module-ngfactory":"5afd58494834f4fb4303","default~pages-home-home-module-ngfactory~pages-landing-landing-module-ngfactory":"bf97fbafe39d2b0e91ee","default~pages-home-home-module-ngfactory~pages-signup-signup-module-ngfactory":"7b80b51c772b720cc756","pages-home-home-module-ngfactory":"e0e659f113fed6a78241","pages-landing-landing-module-ngfactory":"fd8837c9ffe227a10f40","pages-signup-signup-module-ngfactory":"c63a1c47d72f7b5db1bc","game-game-module-ngfactory":"918f75bd3f67bc62520c","pages-forgot-password-forgot-password-module-ngfactory":"029c31ef96bd79e9fe86","pages-forgot-username-forgot-username-module-ngfactory":"46cfcf755caed3f5870b","pages-login-login-module-ngfactory":"39df5948fdc756167586","pages-maintenance-maintenance-module-ngfactory":"a823f83f53badd7f04cf","pages-processing-transaction-processing-transaction-module-ngfactory":"3faf1c97daf946d70d55","pages-verify-email-verify-email-module-ngfactory":"cdabc2765aa8025ec97b","pages-crash-game-crash-game-module-ngfactory":"5c2c790ee44a9072724f","pages-esports-esports-module-ngfactory":"ede49a5c6507871cef68","pages-fishing-fishing-module-ngfactory":"806960db3ac044cad850","pages-launch-game-in-iframe-launch-game-in-iframe-module-ngfactory":"9d91547c747c78a1d085","pages-launch-game-launch-game-module-ngfactory":"93a33a7ef5bd11ea0ffa","pages-live-casino-live-casino-module-ngfactory":"e0dd90f049cb50da7c1c","pages-live-casino-main-live-casino-main-module-ngfactory":"635fe033a82f80541792","pages-lottery-lottery-module-ngfactory":"670b00c0101fb1314de2","pages-slots-main-slots-main-module-ngfactory":"36a1095e6e06a6fa3f16","pages-slots-slots-module-ngfactory":"c45a24001e8686eef3c0","pages-sports-sports-module-ngfactory":"35fc402482a356e3286b","pages-table-table-module-ngfactory":"c8b05925b09efa17d8b0","pages-prediction-prediction-module-ngfactory":"af416aaf9a84d96c308c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
